import { createImmutableSelector } from 'invision-core/src/utilities/create.immutable.selector';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { MetadataCodeTypeDictionarySelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { getFormattedServiceAttributeValue } from './services.list.selectors.helper';
import { EMPTY_ARRAY } from 'invision-core/src/constants/common.constants';
import { UNIT_OF_MEASURES, ENTITLEMENT_PURCHASE_TYPE } from '../../customercare.constants';
import { GROUPED_ENTITLEMENTS_MODAL_TABS } from '../grouped.entitlements.modal.reducer';
var GroupedEntitlementsStoreSelector = function GroupedEntitlementsStoreSelector(state) {
  return state.customercare.groupedEntitlementsModal;
};
export var IsLoadingGroupedEntitlementsSelector = createImmutableSelector([GroupedEntitlementsStoreSelector], function (groupedEntitlementsState) {
  return groupedEntitlementsState.isLoading;
});
export var GroupedEntitlementsSelectedTabSelector = createImmutableSelector([GroupedEntitlementsStoreSelector], function (groupedEntitlementsState) {
  return groupedEntitlementsState.selectedTab;
});
export var GroupedEntitlementsSelector = createImmutableSelector([GroupedEntitlementsStoreSelector], function (groupedEntitlementsState) {
  return groupedEntitlementsState.data.SharedEntitlementBalances && groupedEntitlementsState.data.SharedEntitlementBalances.length ? groupedEntitlementsState.data.SharedEntitlementBalances : groupedEntitlementsState.data.ServiceEntitlementBalances;
});
export var GroupedEntitlementsAvailableForPurchaseSelector = createImmutableSelector([GroupedEntitlementsSelector], function (groupedEntitlements) {
  return (groupedEntitlements || EMPTY_ARRAY).filter(function (entitlement) {
    return entitlement.AvailableForPurchase === ENTITLEMENT_PURCHASE_TYPE.PURCHASE_AND_USAGE || entitlement.AvailableForPurchase === ENTITLEMENT_PURCHASE_TYPE.PURCHASE_ONLY;
  });
});
export var GroupedEntitlementsAvailableForUsageSelector = createImmutableSelector([GroupedEntitlementsSelector], function (groupedEntitlements) {
  return (groupedEntitlements || EMPTY_ARRAY).filter(function (entitlement) {
    return entitlement.AvailableForPurchase === ENTITLEMENT_PURCHASE_TYPE.USAGE_ONLY || entitlement.AvailableForPurchase === ENTITLEMENT_PURCHASE_TYPE.PURCHASE_AND_USAGE;
  });
});
export var GroupEntitlementsWithFormattedServiceAttributeSelector = createImmutableSelector([GroupedEntitlementsSelectedTabSelector, GroupedEntitlementsSelector, GroupedEntitlementsAvailableForPurchaseSelector, GroupedEntitlementsAvailableForUsageSelector, MetadataCodeTypeDictionarySelector(CODES.ServiceAttribute), MetadataCodeTypeDictionarySelector(CODES.RegularExpression)], function (selectedTab, allEntitlements, entitlementsForPurchase, entitlementsForUsage, serviceAttributes, regularExpressions) {
  var result = EMPTY_ARRAY;
  if (allEntitlements && allEntitlements.length) {
    if (allEntitlements[0].BalanceUnitCode === UNIT_OF_MEASURES.CURRENCY) {
      if (selectedTab === GROUPED_ENTITLEMENTS_MODAL_TABS.AVAILABLE_FOR_PAYMENT) {
        result = entitlementsForPurchase;
      } else {
        result = entitlementsForUsage;
      }
    } else {
      result = allEntitlements;
    }
  }
  return result.length && result.map(function (entitlement) {
    var owningService = entitlement.EntitlementIdentifier && entitlement.EntitlementIdentifier.OwningServiceIdentifier;
    if (owningService) {
      entitlement = entitlement.setIn(['EntitlementIdentifier', 'OwningServiceIdentifier', 'FormattedValue'], getFormattedServiceAttributeValue(owningService.ServiceAttributeId, owningService.Value, serviceAttributes, regularExpressions));
    }
    return entitlement;
  }) || EMPTY_ARRAY;
});